import React, { FC } from 'react';
import { Titled } from 'react-titled';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Flex, Card, Text } from '@resideo/blueprint-react';
import ResideoLogo from 'components/logos/resideo-knockout-logo-large.svg?react';
import AppLayout from 'components/common/AppLayout';

import { useSignUpContext } from './context';

export const BorderCard = styled(Card)`
  margin-bottom: ${({ theme }) => theme.space.small};
  border: 2px solid ${({ theme }) => theme.colors.background};
`;

const StyledResideoLogo = styled(ResideoLogo)`
  height: ${({ theme }) => theme.fontSizes.xxLarge};
  margin-bottom: ${({ theme }) => theme.space.large};
`;

const MainContainer = styled(Flex)`
  height: 90vh;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10%;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.small}) {
    width: 90%;
    overflow: hidden;
    margin-left: 5%;
  }
`;

const EmailContainer = styled(Flex)`
  flex-direction: column;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.small}) {
    padding-top: 22px;
  }
`;

const EmailText = styled(Text)`
  padding-bottom: 2rem;
  font-weight: 700;
  font-size: 1.25rem;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.small}) {
    overflow-wrap: break-word;
    width: 300px;
  }
`;

const Success: FC = (): JSX.Element => {
  const { t } = useTranslation();
  const { signUpValues } = useSignUpContext();

  return (
    <Titled
      title={(title: string) => `${t('signUp.success.title')} - ${title}`}>
      <AppLayout showHeader={false} showLeftNav={false} showGreyPanel={true}>
        <MainContainer>
          <BorderCard
            borderRadius={['small']}
            maxHeight={['auto', '796px']}
            maxWidth='1272px'
            marginBottom='large'
            padding={'50px'}
            paddingLeft={'200px'}
            paddingRight={'200px'}
            width='100%'>
            <Flex flexDirection='column' alignItems='center'>
              <StyledResideoLogo />
              <Flex marginBottom={['small', 'large']}>
                <Text
                  fontWeight='bold'
                  fontSize='large'
                  width='max-content'
                  data-test-success-header>
                  {t('signUp.success.heading')}
                </Text>
              </Flex>
              <EmailContainer>
                <Text textAlign='left' paddingBottom='small'>
                  {t('signUp.success.description')}
                </Text>
                <EmailText>{signUpValues.email}</EmailText>
                <Text paddingBottom='small'>
                  {t('signUp.success.descriptionTwo')}
                </Text>
                <Flex width={'100%'}>
                  <Text textAlign='left'>
                    {t('signUp.success.linkExpires')}
                  </Text>
                </Flex>
              </EmailContainer>
            </Flex>
          </BorderCard>
        </MainContainer>
      </AppLayout>
    </Titled>
  );
};

export default Success;
